// extracted by mini-css-extract-plugin
module.exports = {"banner-list":"styles_banner-list__nPfWC"};